import { Component, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { TemplateConfirmModalComponent } from 'app/shared/components/template-confirm-modal/template-confirm-modal.component';
import { EmployeeTeamListTableDataService } from '../../services/employee-team-list-tabledata.service';
import { EmployeeTeamEditModalComponent } from '../../employee-team-edit-modal/employee-team-edit.component';
import { EmployeeTeamService } from '../../services/employee-team.service';
import { BaseListTableComponent } from 'app/core/services/data-services/base-table-list-component';

@Component({
    selector: 'app-employee-team-list-table',
    templateUrl: './employee-team-list-table.component.html',
    styleUrls: ['./employee-team-list-table.component.css']
})
export class EmployeeTeamListTableComponent extends BaseListTableComponent<EmployeeTeamListTableDataService> {

    bsModalRef: BsModalRef;

    canCreate: boolean = true;
    canUpdate: boolean = false;
    canDelete: boolean = false;

    constructor(
        protected _cdr: ChangeDetectorRef,
        protected _employeeTeamService: EmployeeTeamService,
        protected _modalService: BsModalService,
        protected _toastr: ToastrService,
        protected _location: Location
    ) {
        super(_employeeTeamService, _toastr, _location);
    }

    /* Events */
    /*-----------*/

    onCreateTeam() {
        if (!this.canCreate) {
            return;
        }

        var modalTile = 'Create New Employee Team';
        this._employeeTeamService.initEmployeeTeamActionModel(modalTile, null, null);
        this.bsModalRef = this._modalService.show(EmployeeTeamEditModalComponent, { class: 'modal-lg' });

        // Subscribe to the onDataUpdated event
        this.bsModalRef.content.onDataUpdated.subscribe(() => {
            this.refreshTableData();
        });
    }

    onEditTeam(team: any): void {
        if (!this.canUpdate) {
            return;
        }

        var title = 'Update: ' + team.TeamName;
        var employeeTeamToEdit = this._employeeTeamService.mapTableDataRowToViewModel(team);
        this._employeeTeamService.initEmployeeTeamActionModel(title, team.Id, employeeTeamToEdit);
        this.bsModalRef = this._modalService.show(EmployeeTeamEditModalComponent, { class: 'modal-lg' });

        // Subscribe to the onDataUpdated event
        this.bsModalRef.content.onDataUpdated.subscribe(() => {
            this.refreshTableData();
        });
    }

    onDeleteTeam(team: any) {
        if (!this.canDelete) {
            return;
        }

        this.bsModalRef = this._modalService.show(TemplateConfirmModalComponent, { class: 'modal-lg' });

        this.bsModalRef.content.title = 'Are you sure you want to delete ' + team.TeamName + '?';
        this.bsModalRef.content.confirmation = () => {
            this._employeeTeamService.deleteEmployeeTeam(team.Id)
                .subscribe(
                    () => {
                        this._toastr.success('Employee Team Deleted Successfully');
                        this.refreshTableData();
                    },
                    error => {
                        this.handleError(error);
                        this.refreshTableData();
                    }
                );
        };    }

    refreshTableData() {
        this._employeeTeamService.refreshTableDataInclFilters()
            .subscribe(
                x => {
                },
                error => {
                    this.handleError(error);
                }
            );
    }

    ngOnInit() {
        super.ngOnInit(); // Call the ngOnInit method of the base component

        this._employeeTeamService.getRBACPermissions().subscribe(x => {
            this.canCreate = x.create;
            this.canUpdate = x.update;
            this.canDelete = x.delete;
        });
    }

    registerTDSEventHandlers(): void {
        this.subscriptions.push(this._employeeTeamService.subscribeToTDSDataRefreshed(() => {
            console.log(this.tableDataService.identifier + ' data has been refreshed');
            // Handle the refreshTableDataComplete$ event here
        }));

        this.subscriptions.push(this._employeeTeamService.subscribeToTDSFilterOptionsRefreshed(() => {
            console.log(this.tableDataService.identifier + ' filter options have been loaded');
            // Handle the filterOptionsLoadComplete$ event here
        }));

        this.subscriptions.push(this._employeeTeamService.subscribeToTDSRefreshAllCompleted(() => {
            console.log(this.tableDataService.identifier + ' filters & data has been refreshed');
            // Handle the refreshAllComplete$ event here
        }));

        this.subscriptions.push(this._employeeTeamService.subscribeToTDSErrorOccurred(() => {
            console.log(this.tableDataService.identifier + ' an error occurred');
            // Handle the errorOccurred$ event here
        }));
    }

    ngOnDestroy() {
        super.ngOnDestroy(); // Call the ngOnDestroy method of the base component
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
